<template>
  <ul :class="$style.operating">
    <li v-for="(item, index) in list" :key="index" @click="goPath(item, index)">
      {{ item.title }}
    </li>
  </ul>
</template>
<script>
export default {
  name: "operating",
  props: {
    list: {
      type: Array
    }
  },
  methods: {
    /**
     * @description 页面跳转
     * @param {object} item  - 跳转信息
     * @param {number} index - 索引
     */
    goPath(item, index) {
      if (this.list[index].type) {
        this.$router.push({
          path: this._anchor[this.list[index].type].path
        });
      } else {
        this.$parent.handlerShow(item.title);
      }
    }
  }
};
</script>
<style lang="less" module>
ul.operating {
  .flex-center();
  li {
    a {
      font-size: 0.3rem;
      color: @green;
    }
  }
  margin-top: 0.48rem;
  li {
    color: @green;
    font-size: 0.3rem;
    cursor: pointer;
  }
  li:nth-of-type(2),
  li:nth-of-type(3) {
    text-align: left;
    padding-left: 3%;
    margin-left: 3%;
    border-left: 0.02rem solid @green;
    line-height: 1.15;
  }
}
</style>
